// export const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://uatatg.cosmote.gr/portal-sc-api/";

export const STRAPI_BASE_URL = "https://content.cosmote.gr";

export const USE_JENKINS_PROPS = false;

export const BASE_URL = "https://www.cosmote.gr";
export const IS_LOCAL_ENV = 'false';
export const LOCAL_MOCK_DATA = `${window.location.origin}/commerce/mock/responses`;

export const TOKEN_NAME = 'PORTAL_JWT';
export const SERVICE_ENDPOINTS = {

  PRICE_LIST_CATEGORIES: BASE_URL + '/postpaid-sales-api/pricelist/categories/{lang}',
  PRICE_LIST_VERSIONS: BASE_URL + '/postpaid-sales-api/pricelist/versions/{lang}?mtbId={mtbId}',
  PRICE_LIST_REVISION: BASE_URL + '/postpaid-sales-api/pricelist/{lang}?mtbId={mtbId}&version={version}',

  SC_CONTENT: BASE_URL + '/sc/content',
  KSYB_INDIVIDUAL_URL: BASE_URL + '/cs/cosmote/{lang}/call_us.html',
  KSYB_CHECK_TAX_ID: BASE_URL + '/portal-sc-api/ksyb/eligibility',
  KSYB_OPTIONS: BASE_URL + '/portal-sc-api/ksyb/register',
  KSYB_GET_FAQS : STRAPI_BASE_URL + '/api/common-faq-categories?populate=*&locale={lang}&filters[name][$eq]=KSYB2&filters[Channel][$eq]=Cosmote.gr',
  KSYB_GET_CARDS : STRAPI_BASE_URL + '/api/help-pages?filters[pageId][$eq]=KSYB_gridlinks&populate=reusables&populate=reusables.reusable&populate=reusables.reusable.image&populate=reusables.item&populate=reusables.links&populate=reusables.item.image&locale={lang}',
  KSYB_GET_HTML :STRAPI_BASE_URL + "/api/business-pages?filters[pageId][$eq]=ksyb_html&populate=reusables&populate=reusables.reusable&populate=reusables.reusable.image&populate=reusables.item&populate=reusables.links&populate=reusables.items&populate=reusables.grids&populate=reusables.grids.image&locale={lang}"

};
